'use client'
import { linksItems, NavItem, navItems } from '@/constants/navs'
import Link from 'next/link'
import { useSearchParams } from 'next/navigation'
import { Suspense } from 'react'
import { Logo } from './logo'

function buildFooterHref(link: string, queryString: string) {
  if (!link.startsWith('/') || !queryString) return link
  return `${link}?${queryString}`
}

const FooterLink = ({ idx, navItem }: { idx: number; navItem: NavItem }) => {
  const searchParams = useSearchParams()
  const queryString = searchParams.toString()
  const href = navItem.link ? buildFooterHref(navItem.link, queryString) : '/#'

  return (
    <Link
      className="relative py-2 text-[#b8c6ff]/70 hover:text-gray-200"
      key={`link=${idx}`}
      onClick={event => {
        event.preventDefault()
        if (navItem.link) {
          window.location.href = href
        }
      }}
      href={href}
    >
      <span className="relative z-20">{navItem.name}</span>
    </Link>
  )
}

export function Footer() {
  return (
    <Suspense>
      <div className="relative w-full overflow-hidden border-t border-neutral-100 bg-gray-800 px-8 py-20">
        <div className="container mx-auto max-w-6xl">
          <div className="mb-4">
            <Logo href="https://cdn.aitubiao.com/static/images/itubiao/logo-white.png" />
          </div>

          {/* Navigation Links */}
          <nav className="mb-4 flex flex-wrap gap-x-10 text-xl md:gap-x-15">
            {navItems.map((navItem: NavItem, idx: number) => (
              <FooterLink key={`link=${idx}`} idx={idx} navItem={navItem} />
            ))}
          </nav>

          {/* Copyright */}
          <div className="space-y-4 text-base text-gray-500">
            <p>© Copyright {new Date().getFullYear()} 武汉镝次元数据科技有限公司</p>
            <p className="flex flex-col md:block">
              <span>增值电信业务经营许可证: 鄂B2-20210015</span>
              <span className="hidden md:inline">   ｜    </span>
              <span><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=42011102003836" target="_blank">鄂公网安备 42011102003836号</a> <a href="https://beian.miit.gov.cn/" target="_blank">鄂ICP备15019128号-9</a></span>
            </p>
          </div>
          <div className="outline-foreground-dividers mt-10 h-0 w-full outline outline-1 outline-offset-[-0.50px]"></div>
          {/* Friend Links */}
          <div className="pt-8">
            <nav className="mb-4 flex flex-wrap gap-x-5 text-base md:gap-x-7">
              <span className="py-2 text-base text-[#b8c6ff]/70">友情链接:</span>
              {linksItems.map((navItem: NavItem, idx: number) => (
                <FooterLink key={`link=${idx}`} idx={idx} navItem={navItem} />
              ))}
            </nav>
          </div>
        </div>
      </div>
    </Suspense>
  )
}
